"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDOMPipeline = void 0;
var __1 = require("..");
var createDOMFrameScheduler_1 = require("./createDOMFrameScheduler");
var Device_1 = require("../Device");
/**
 * Reduces boilerplate for browser-based applications. Example usage:
 *
 * ```
 * const {pipeline, requestRender} = ff.createDOMPipeline(canvas, p => p.clear().paintAll(objects));
 *
 * pipeline
 *     .use(new ff.TrianglePainter())
 *     .use(new ff.RectanglePainter());
 *
 * requestRender();
 * ```
 */
function createDOMPipeline(canvas, render) {
    var _a = createDOMFrameScheduler_1.createDOMFrameScheduler(function () { return render(pipeline); }), requestRender = _a.requestRender, cancelRender = _a.cancelRender;
    var pipeline = new __1.Pipeline(canvas, Device_1.Device.browser(), requestRender, function (e) { return console.error(e); });
    pipeline.applyPixelRatio();
    return {
        pipeline: pipeline,
        requestRender: requestRender,
        cancelRender: cancelRender
    };
}
exports.createDOMPipeline = createDOMPipeline;
//# sourceMappingURL=createDOMPipeline.js.map